<template>
  <div>
      <div class="button-group">
        <a-button type="primary" class="top_btn" @click="addTemplate" v-has="'btn_add'" >添加模板</a-button>
        <a-button type="primary" class="top_btn" @click="listOrder()" v-has="'btn_listorder'" >排序</a-button>

          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm_delete(selectedRowKeys)"
                  @cancel="()=>{}"
                  :disabled="!hasSelected"
          >
              <a-button type="primary"   :disabled="!hasSelected"   v-has="'btn_delete'" style="margin-right: 10px" >删除</a-button>

          </a-popconfirm>
          <a-button type="primary" class="top_btn" :disabled="!hasSelected" @click="is_push(1)" v-has="'btn_release'" >发布</a-button>
        <a-button type="primary" class="top_btn" :disabled="!hasSelected" @click="is_push(0)" v-has="'btn_unrelease'" >取消发布</a-button>
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </div>

      <div class="search-group">
        <a-input v-model="search.name"/>
        <a-button type="primary" class="top_btn" @click="getList()">查询</a-button>
        <a-button  class="top_btn" @click="empty">重置</a-button>
      </div>
    <div style="clear:both"></div>
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
      >
        <span slot="list_order" slot-scope="text, record">
            <a-input v-model="record.list_order" class="inputs" id="list_order"  size="small" oninput = "value=value.replace(/[^\d]/g,'')" />
        </span>

        <span slot="status" slot-scope="text, record">
            <a-switch
            checked-children="发布"
            un-checked-children="草稿"
            @click="onChange(record)"
            :checked="text == 1 ? true : false"
            />
        </span>

        <span slot="action" slot-scope="text, record">
            <a
            @click="editTemplate([record.id])"
            v-has="'btn_edit'"
            >编辑<a-divider type="vertical"/></a>

            <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm_delete([record.id])"
                  @cancel="()=>{}"
            >
                <a v-has="'btn_delete'" >删除</a>
            </a-popconfirm>
        </span>
      </a-table>
  </div>
</template>
<script>
import API from "./api";
import {changStatus, removeById,orderList} from "../../utils/utils"
    export default {
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 0, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                },
                search: {
                    name: "",
                },
                columns,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                sortLists:[],
                editId: null
            };
        },
        created() {
            this.$store.state.adminleftnavnum = "/EmailTemplate/EmailTemplateList"; //设置左侧导航2-2 active
        },
        methods: {
            getList(page) {
                API.emailTemplate.EMAILTEMPLATE({page: page || 1, ...this.search}).then((res) => {
                    this.data = res.data.data.info.data
                    this.pagination.total=res.data.data.info.total
                    this.pagination.pageSize=res.data.data.info.per_page
                    this.pagination.current=res.data.data.info.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                });
            },
            onChange(row) {
                let Json = { id: row.id, status: row.status == 0 ? 1 : 0 };
                API.emailTemplate.CHANG_STATUS([Json]).then(() => {
                    this.getList();
                });
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            getchangId(data) {
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < data.length; i++) {
                    sortListOrder.id = data[i].id
                    sortListOrder.list_order = data[i].list_order
                    this.sortLists.push(sortListOrder)
                    sortListOrder = {}
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
            },
            // listOrder() {
            //     this.getchangId(this.data)
            //     API.emailTemplate.LIST_ORDER(this.sortLists).then(res => {
            //         this.getList()
            //     })
            // },
            listOrder() {
                this.getchangId(this.data)
                orderList(API.emailTemplate.LIST_ORDER, this.sortLists).then(res => {
                    if (res == true) {
                        this.getList(this.page)
                    }
                })
            },
            empty() {
                this.loading = true
                this.search.name =''
                this.getList()
            },
            is_push(type) {
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson['status'] = type;
                    dataArr.push(dataJson)
                })
                changStatus(API.emailTemplate.CHANG_STATUS,  dataArr ).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys = []
                    }
                })
                // API.emailTemplate.CHANG_STATUS(dataArr).then(res => {
                //     this.getList()
                //     this.selectedRowKeys = []
                // })
            },
            // 添加模板
            addTemplate() {
                this.$router.push({ path: "/EmailTemplate/addTemplate" });
            },

            // 删除
            confirm_delete(id) {
                removeById(API.emailTemplate.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
                // API.emailTemplate.DELE(id).then(res => {
                //     this.getList()
                //     this.selectedRowKeys = []
                // })
            },

            // 编辑模板
            editTemplate(id) {
                 this.$router.push(`/EmailTemplate/addTemplate?id=${id}`)
            }

        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted() {
            this.getList();
        },
    }
    const columns = [
        {
            title: '排序',
            dataIndex: 'list_order',
            width: "8%",
            ellipsis: true,
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: '模板名称',
            dataIndex: 'name',
            width: "50%",
            ellipsis: true,
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            width: "200px",
            ellipsis: true,
        },
        {
            title: '状态',
            dataIndex: 'status' ,
            scopedSlots: { customRender: "status" },
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: "action" },
            ellipsis: true,
        },
    ];
</script>
<style scoped>
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
</style>
